import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import LoaderModal from "../../../../components/modal/LoaderModal";
import { CONFIG } from "../../../../config";
import accountManagement from "../../../../apis/accountManagement";
import { Row, Col, Alert, Table } from "react-bootstrap";
import "../../../../components/dashboard/content/report/tryout/circlebar.css";
// import "./reportsbmptn.css";
import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import { FooterReport, Gap, GridInline, LabelLevel, LabelTitle, Line, ProgressBar } from "../../../../components/Global";
import HeaderReportPeminatan from "../../component/HeaderReportPeminatan";
import HeaderAgcu from "./HeaderAgcu";

class ReportDinasAGCU extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showIndikator: false,
            jumMapel: null,
            dataMapel: null,
            detail: {},
            subtesSekolah: [],
            statistikSubtesSekolah: [],
            skorNonCampuran: {},
            skorSaintek: {},
            skorSoshum: {},
            dataAll: [],
            kodeTahunAjaran: null,
            idJadwal: null,
        };
    }

    async componentDidMount() {
        document.title = "Report AGCU";
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const param = this.props.match.params;
        const ta = param.idKelas + "/" + param.idJadwal;
        console.log("====================================");
        console.log(this.props);
        console.log("====================================");
        const response = await accountManagement.get(CONFIG.REPORT_DINAS_SNBT + "?kodeTahunAjaran=" + ta + "&idJadwal=" + param.kelompok).catch(function (error) {
            console.log(error);
        });
        console.log(response);
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subtesSekolah: response.data.data.subtesSekolah,
                    statistikSubtesSekolah: response.data.data.statistikSubtesSekolah,
                });
            }
            this.setState({ isFetching: false });
        }
        this.setState({ isFetching: false });
    };

    renderTableParent() {
        let { subtesSekolah } = this.state;
        if (!__.isEmpty(subtesSekolah)) {
            return (
                <Table className="table">
                    <TableHead>
                        <TableRow style={{ backgroundColor: "#BEF264" }}>
                            <TableCell></TableCell>
                            <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Nama Sekolah</TableCell>
                            <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Jumlah Siswa</TableCell>
                            {subtesSekolah[0].nilaiMapel.map((mapel, mp) => (
                                <TableCell style={{ fontSize: "12px", fontWeight: "bold" }} key={mp}>{mapel.namaMapel}</TableCell>
                            ))}
                            <TableCell style={{ fontSize: "12px", fontWeight: "bold" }} rowSpan="2" scope="col">
                                Kategori
                            </TableCell>
                            <TableCell style={{ fontSize: "12px", fontWeight: "bold" }} className="font-tbl-head" rowSpan="2" scope="col">
                                rata - rata
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subtesSekolah.map((item, sw) => (
                            <TableRow key={sw}>
                                <TableCell className="table-font-kecil-tengah">{sw + 1}.</TableCell>
                                <TableCell className="table-font-kecil">{item.namaSekolah}</TableCell>
                                <TableCell className="table-font-kecil-tengah">{item.jumlahSiswa}</TableCell>
                                {item.nilaiMapel.map((mapel, mp) => (
                                    <TableCell key={mp} className="table-font-kecil-tengah">
                                        {mapel.rataMapel}
                                    </TableCell>
                                ))}
                                <TableCell className="table-font-kecil-tengah">{item.rataSekolah}</TableCell>
                                <TableCell>
                                    <LabelLevel color={"#fff"} bgColor={item.kategori === "Rendah" ? "#FFB703" : item.kategori === "Sedang" ? "#52B788" : item.kategori === "Tinggi" ? "#5C95FF" : "#E63946"} level={item.kategori} emoticon={false} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            );
        } else {
            return (
                <Row>
                    <Col>
                        <b>Data tidak tersedia</b>
                    </Col>
                </Row>
            );
        }
    }

    render() {
        const { subtesSekolah, statistikSubtesSekolah } = this.state;

        const today = new Date();
        const suflix = today.getHours() >= 12 ? " PM" : " AM";
        const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

        require("./ReportDinasAGCU.css");
        return (
            <div>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="report-page">
                    <HeaderReportPeminatan pageNumber={'01'} desc={'https://eduprime.co.id/'} title={'ACADEMIC GENERAL CHECK UP'} subtitle={'Report Dinas'} logoCbt={'/assets/image/logo_agcu.png'} />
                    <Gap height={40} />
                    <div
                        style={{
                            paddingLeft: "5%",
                            paddingRight: "5%",
                        }}
                    >
                        <div style={{ marginTop: "10px" }}>
                            <div className="biodata-left">
                                <table width="100%">
                                    <tr>
                                        <td style={{ height: "25px", color: "lightgray" }} width="50%">
                                            Wilayah
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ height: "25px" }} width="50%">
                                            {this.props.account.namaUser}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className="biodata-right">
                                <table>
                                    <tr>
                                        <td style={{ height: "25px" }} width="100%">
                                            <b>REPORT DINAS</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        {/* <Line color={"#E9ECEF"} /> */}

                        <b>RATA-RATA SUBTES SEKOLAH</b>
                        <Gap height={20} />

                        <Row>
                            <Col>{this.renderTableParent()}</Col>
                        </Row>

                        <div id="btn_print">
                            <div className="fixed_button">
                                <button className="btn btn-outline-primary btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* page 2 */}
                <div className="report-page">
                    {/* Begin :: Header */}
                    <HeaderAgcu title={'Hasil Academic General CheckUp'} subtitle={this.props.account.namaUser} page={2} />
                    <Gap height={30} />
                    {/* End :: Header */}
                    <div className="section-five">
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                                display: "inline-block",
                                width: "93%",
                                verticalAlign: "middle",
                            }}
                        >
                            <LabelTitle label={"Grafik Rata-Rata Mata Pelajaran Sekolah"} size={22} bolder={700} color={"#000000"} />
                        </div>
                        <Gap height={20} />
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                            }}
                        >
                            <Table className="table">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: "#BEF264" }}>
                                        <TableCell></TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Nama Sekolah</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Grafik Rata-Rata</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subtesSekolah.map((item, sw) => (
                                        <TableRow>
                                            <TableCell className="table-font-kecil-tengah">{sw + 1}.</TableCell>
                                            <TableCell className="table-font-kecil">{item.namaSekolah}</TableCell>
                                            <TableCell>
                                                <GridInline width={"70%"} marginBottom="-2%">
                                                    <ProgressBar progressColor={"#FB8500"} progressValue={item.rataSekolah} heightBar={15} />
                                                </GridInline>
                                                <GridInline width={"10%"} paddingLeft={25}>
                                                    <LabelTitle label={item.rataSekolah} size={13} bolder={500} color={"#6C757D"} />
                                                </GridInline>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </div>

                {/* page 3 */}
                <div className="report-page">
                    {/* Begin :: Header */}
                    <HeaderAgcu title={'Hasil Academic General CheckUp'} subtitle={this.props.account.namaUser} page={3} />
                    <Gap height={30} />
                    {/* End :: Header */}
                    <div className="section-five">
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                                display: "inline-block",
                                width: "93%",
                                verticalAlign: "middle",
                            }}
                        >
                            <LabelTitle label={"Statistik Subtes SNBT Sekolah"} size={22} bolder={700} color={"#000000"} />
                        </div>
                        <Gap height={20} />
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                            }}
                        >
                            <Table className="table">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: "#BEF264" }}>
                                        <TableCell></TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Nama Subtes</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Standar Deviasi</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Terendah</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Tertinggi</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Rata-Rata</TableCell>
                                        <TableCell style={{ fontSize: "12px", fontWeight: "bold" }}>Kategori</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {statistikSubtesSekolah.map((item, sw) => (
                                        <TableRow>
                                            <TableCell className="table-font-kecil-tengah">{sw + 1}.</TableCell>
                                            <TableCell className="table-font-kecil">{item.namaMapel}</TableCell>
                                            <TableCell className="table-font-kecil-tengah">{item.standarDeviasi}</TableCell>
                                            <TableCell className="table-font-kecil-tengah">{item.terendah}</TableCell>
                                            <TableCell className="table-font-kecil-tengah">{item.tertinggi}</TableCell>
                                            <TableCell className="table-font-kecil-tengah">{item.totalNilaiMapel}</TableCell>
                                            <TableCell>
                                                <LabelLevel
                                                    color={"#fff"}
                                                    bgColor={item.kategori === "Rendah" ? "#FF3838" : item.kategori === "Sedang" ? "#FFB703" : item.kategori === "Tinggi" ? "#52B788" : "#FF3838"}
                                                    level={item.kategori}
                                                    emoticon={false}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </div>

                {/* page 4 */}
                <div className="report-page">
                    <HeaderAgcu title={'Hasil Academic General CheckUp'} subtitle={this.props.account.namaUser} page={4} />
                    <Gap height={30} />
                    {/* End :: Header */}
                    <div className="section-five">
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                                display: "inline-block",
                                width: "93%",
                                verticalAlign: "middle",
                            }}
                        >
                            <LabelTitle label={"Grafik Subtes SNBT Sekolah"} size={22} bolder={700} color={"#000000"} />
                        </div>
                        <Gap height={20} />
                        <div
                            style={{
                                paddingLeft: "5%",
                                paddingRight: "5%",
                            }}
                        >
                            <Table className="table" id="rekap">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: "#BEF264" }}>
                                        <TableCell className="th-title v-align-center" rowSpan="2" scope="col">
                                            No
                                        </TableCell>
                                        <TableCell className="th-title v-align-center" rowSpan="2" scope="col">
                                            Nama Subtes
                                        </TableCell>
                                        <TableCell className="th-title v-align-center" rowSpan="2" scope="col">
                                            Rata-Rata
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {statistikSubtesSekolah.map((item, sw) => (
                                        <TableRow>
                                            <TableCell>{sw + 1}.</TableCell>
                                            <TableCell className="table-font-kecil">{item.namaMapel}</TableCell>
                                            <TableCell>
                                                <GridInline width={"70%"} marginBottom="-2%">
                                                    <ProgressBar progressColor={"#FB8500"} progressValue={item.rata} heightBar={15} />
                                                </GridInline>
                                                <GridInline width={"10%"} paddingLeft={25}>
                                                    <LabelTitle label={item.rata} size={13} bolder={500} color={"#6C757D"} />
                                                </GridInline>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(ReportDinasAGCU);
